import React, { useState, useEffect } from 'react';
import { Container, Form, Button, Menu, MenuItem, Input, Message, Image } from 'semantic-ui-react';
import auth from './../Login/auth';
import ReactDataGrid from 'react-data-grid';
import {Toolbar, Data} from "react-data-grid-addons";
import { CSVLink, CSVDownload } from "react-csv";
import logo from '../../img/Logo Horizontal Blanco transparente.png';

//Propiedades de las columnas
const defaultColumnProperties = {
    filterable: true
  };
  
  const NumberFormatter = ({ value }) => {
    return <p style={{textAlign:"right"}}>$ {value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>;
  };

  //Columnas
  const columns = [
    {
      key: "nro_comp",
      name: "Nro. Comp.",
      width: 160
    },
    {
      key: "cod",
      name: "Pto. Vta.",
      width: 70
    },
    {
      key: "cotizacion",
      name: "Cotiz.",
      width: 60
    },
    {
      key: "fecha",
      name: "Fecha",
      width: 120
    },
    {
      key: "vence",
      name: "Vence",
      width: 120
    },
    {
      key: "debe",
      name: "Debe",
      width: 110,
      formatter: NumberFormatter
    },
    {
      key: "haber",
      name: "Haber",
      width: 110,
      formatter: NumberFormatter
    },
    {
      key: "saldo",
      name: "Saldo",
      width: 110,
      formatter: NumberFormatter
    }
  ].map(c => ({ ...c, ...defaultColumnProperties })); 

const handleFilterChange = filter => filters => {
  const newFilters = { ...filters };
  if (filter.filterTerm) {
    newFilters[filter.column.key] = filter;
  } else {
    delete newFilters[filter.column.key];
  }
  return newFilters;
};

const selectors = Data.Selectors;

function getRows(rows, filters) {
    return selectors.getRows({ rows, filters });
} 

export const CuentaCorriente = props => {
    const [fechaDesde, setFechaDesde] = useState();
    const [fechaHasta, setFechaHasta] = useState();
    const [dataCtaCte, setDataCtaCte] = useState([]);
    const [mensajeFechas, setMensajeFechas] = useState(0);
    const [filters, setFilters] = useState({});

    const rows = dataCtaCte;
    const filteredRows = getRows(dataCtaCte, filters); 

    useEffect(() => {
      setFechaDesde(fechaFiltro(true)); 
      setFechaHasta(fechaFiltro(false)); 
    }, [])
  
    function fechaFiltro(desde){
      let date = new Date()
      let day = date.getDate()
      let month = date.getMonth() + 1
      let year = date.getFullYear()
  
      if (desde) year --;

      if (day < 10) day = '0' + day
      if (month < 10) month = '0' + month
  
      return `${year}-${month}-${day}`

    }

    function handleFechaDesde(event, {name, value}){
        setFechaDesde(value);
    }

    function handleFechaHasta(event, {name, value}){
        setFechaHasta(value);
    }

    async function onSubmit(e){
        e.preventDefault();
        var cod_cli = auth.usuario.user[0]['cod_cli'];

        if (fechaDesde === 0 || fechaHasta === 0){
            setMensajeFechas(1);
            return;
        }

        setMensajeFechas(0);
                
        //var url = `http://192.168.87.41:8000/ctacte/${auth.db}/${cod_cli.trim()}?desde=${fechaDesde}&hasta=${fechaHasta}`; 
        var url = `http://webservices.crucianelli.com:8000//ctacte/${cod_cli.trim()}?desde=${fechaDesde}&hasta=${fechaHasta}`; 

        console.log(url);

        //query con fetch api asincronica
        let response = await fetch(url, {
	        'mode': 'cors',
	        'headers': {
            	'Access-Control-Allow-Origin': '*',
        	}
        });
        
        let data = await response.json();
        
        if (data.length !== 0) {
            setDataCtaCte(data.cta_cte);
            //console.table(data.cta_cte)            
        }
    }

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return (
        <div style={{width: '90%'}}>
            <Menu inverted color='red'>
                <MenuItem><h3>Cuenta Corriente</h3></MenuItem>     
                <MenuItem><h5>{auth.nombre}</h5></MenuItem>   
                <MenuItem position="right"><Image src={logo} size='small'></Image></MenuItem>
            </Menu>
            <Container>
                <Form onSubmit={onSubmit}>
                    <Form.Group widths='equal'>
                        <Form.Field 
                            fluid 
                            label='Desde' 
                            control={Input}
                            onChange={handleFechaDesde}
                            value={fechaDesde}
                            type="date"/>
                        <Form.Field 
                            fluid 
                            label='Hasta' 
                            control={Input}
                            onChange={handleFechaHasta}
                            value={fechaHasta}
                            type="date"/>   
                        <Button 
                            type="submit" 
                            color='blue'
                            compact='true'>
                            Mostrar
                        </Button>                                     
                    </Form.Group>                       
                </Form>
                    {mensajeFechas?<Message warning>
                        <Message.Header>Ingrese un rango de fechas válido</Message.Header>
                    </Message>: <div></div> }
                    
            </Container>
                    <ReactDataGrid
                        columns={columns}
                        rowGetter={i => filteredRows[i]}
                        rowsCount={filteredRows.length}
                        minHeight={500}
                        enableCellAutoFocus={false}
                        toolbar={<Toolbar enableFilter={true} filterRowsButtonText = 'Filtrar' />}
                        onAddFilter={filter => setFilters(handleFilterChange(filter))}
                        onClearFilters={() => setFilters({})}
                    />
                    <Message warning>
                        <Message.Header>Punto de venta 0020 correspondiente a facturas en dolares expresadas en pesos. 
                              Para estas facturas se tomará la cotización del dólar del efectivo pago.</Message.Header>
                      </Message>
                    <CSVLink data={dataCtaCte} filename={"cta_cte.csv"}>Exportar a Excel.</CSVLink>
        </div>
    );
}    